<template>
    <v-container>
        <v-row>
            <v-img :src="require('@/assets/gifiqr-billeder-legeplads.jpg')"/>
        </v-row>
        <v-row>
            <v-col md="8" align="left">
                <h1>Profilering</h1>
                <h4>Er det vigtigt for dig, at dine besøgende har let adgang til din verden via sjove oplevelser og anderledes viden? Så brug gofiqr.</h4>
                <p>Med gofiqr kan du profilere dig kreativt på messer, ude i kunderummet, i venteværelset eller på dine udendørsarealer.</p>

                <h2>Hvordan?</h2>
                <p>Du sætter QR-koden på strategiske gode steder i dit kunderum; fx i receptionsområdet, venteværelset eller ude på dine udendørsarealer</p>
                <p>Dine besøgende kan nu udnytte ventetiden til at tilgå din information med deres QR-kodescannere på telefonen</p>
                <p>Alle typer informationer; fx skattejagter, Fun Facts, aktivitetsforslag og virksomhedsfilm, præsenteres nu i dit visuelle, professionelle univers, som er beskyttet mod reklamer</p>

                <h2>Brug den til:</h2>
                <p>Lad dine kunder se filmen om jer, når de scanner QR-koden i venteværelset</p>
                <p>Lad dine besøgende læse mere om de kunstværker, du udstiller på museet eller i kantinen</p>
                <p>Lad dine gæster i alle aldre få sjove oplevelser eller aktivitetsforslag, når de scanner QR-koden fx på legepladsen, på jeres udendøresarealer eller på låne-cyklerne.</p>

                <h4>gofiqr giver dig mulighederne. Du bestemmer indholdet. gofiqr sørger for, at dine besøgende altid kan få et bredere billede af dig og din virksomhed.</h4>

                <v-divider class="my-5"/>

                <v-card flat class="mb-5">
                    <v-img :src="require('@/assets/profileing01.jpg')"/>
                </v-card>
                <h2>Med gofiqr giver du dine besøgende mulighed for at få:</h2>
                <p>En sjov og anderledes oplevelse af dig og din virksomhed</p>
                <p>Adgang til aktivitetsforslag og fun facts knyttet til stedet</p>
                <p>Aktuel viden relateret til deres besøg hos dig</p>
                <p>Information og vejledning på deres eget sprog</p>

                <v-divider/>
            </v-col>
            <v-col md="4" align="left">
                <ContactForm :know-more="true" :try-gofiqr="true"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ContactForm from "@/components/ContactForm";
    export default {
        name: "ProfileingPage",
        components: {ContactForm}
    }
</script>

<style scoped>

</style>